import {
  mdiAirConditioner,
  mdiAirFilter,
  mdiAlarmLight,
  mdiAlarmPanel,
  mdiAnchor,
  mdiBagSuitcase,
  mdiBalcony,
  mdiBank,
  mdiBathtub,
  mdiBatteryCharging,
  mdiBed,
  mdiBellRing,
  mdiBlinds,
  mdiBoomGate,
  mdiBorderTopVariant,
  mdiBriefcaseVariant,
  mdiCctv,
  mdiCeilingLight,
  mdiCog,
  mdiCubeOutline,
  mdiDolly,
  mdiDoor,
  mdiDoorClosed,
  mdiDoorOpen,
  mdiDoorSlidingLock,
  mdiDoorbellVideo,
  mdiElectricSwitch,
  mdiElevator,
  mdiElevatorPassenger,
  mdiEngine,
  mdiEvStation,
  mdiExitRun,
  mdiFan,
  mdiFaucet,
  mdiFence,
  mdiFire,
  mdiFireAlert,
  mdiFireExtinguisher,
  mdiFireHydrant,
  mdiFlash,
  mdiFloorPlan,
  mdiFlower,
  mdiFormatPaint,
  mdiGarage,
  mdiGauge,
  mdiGestureTapButton,
  mdiGrass,
  mdiHanger,
  mdiHeatPump,
  mdiHome,
  mdiHomeFloorB,
  mdiHomeGroup,
  mdiHomeModern,
  mdiHomeRoof,
  mdiHvac,
  mdiLayers,
  mdiLayersOutline,
  mdiLayersTriple,
  mdiLightbulbGroup,
  mdiLightningBolt,
  mdiLock,
  mdiLockOpenAlert,
  mdiMailbox,
  mdiMeterElectric,
  mdiMeterGas,
  mdiMonitorDashboard,
  mdiNature,
  mdiOfficeBuilding,
  mdiOutdoorLamp,
  mdiPackageVariantClosed,
  mdiParking,
  mdiPineTree,
  mdiPipe,
  mdiPipeValve,
  mdiPlus,
  mdiPowerPlug,
  mdiPowerSocketEu,
  mdiRadiator,
  mdiRoadVariant,
  mdiRug,
  mdiServer,
  mdiServerNetwork,
  mdiShapeOutline,
  mdiShieldHalfFull,
  mdiShower,
  mdiSilverwareForkKnife,
  mdiSlide,
  mdiSmoke,
  mdiSmokeDetector,
  mdiSnowflake,
  mdiSofa,
  mdiSolarPanel,
  mdiSprinklerFire,
  mdiSprout,
  mdiStairs,
  mdiStar,
  mdiStopCircle,
  mdiStorageTank,
  mdiStore,
  mdiStove,
  mdiTag,
  mdiTextureBox,
  mdiThermometer,
  mdiToilet,
  mdiTree,
  mdiValve,
  mdiVectorLine,
  mdiVectorSquare,
  mdiWalk,
  mdiWall,
  mdiWallpaper,
  mdiWater,
  mdiWaterBoiler,
  mdiWaterCheck,
  mdiWaterPump,
  mdiWaterThermometer,
  mdiWheelchairAccessibility,
  mdiWifi,
  mdiWindowClosedVariant,
} from '@mdi/js'

/**
 * `ASSET_TYPE_ICONS` — the kebab-case MDI name an asset type stores in
 * `asset_types.icon`, mapped to its `@mdi/js` path (spec 2026-09-17-04).
 *
 * Every name `res-provisioning/types/02-asset-types.json` ships is listed
 * here, plus a few generic ones the admin icon picker offers for a type an
 * organisation invents. `asset-type-icons.test.ts` fails when the two drift
 * apart, in either direction.
 *
 * **Never `import * as mdi from '@mdi/js'`.** The package is 7,400 paths; the
 * named imports above are what keeps the bundle to the 118 this app draws.
 */
export const ASSET_TYPE_ICONS: Record<string, string> = {
  'air-conditioner': mdiAirConditioner,
  'air-filter': mdiAirFilter,
  'alarm-light': mdiAlarmLight,
  'alarm-panel': mdiAlarmPanel,
  'anchor': mdiAnchor,
  'bag-suitcase': mdiBagSuitcase,
  'balcony': mdiBalcony,
  'bank': mdiBank,
  'bathtub': mdiBathtub,
  'battery-charging': mdiBatteryCharging,
  'bed': mdiBed,
  'bell-ring': mdiBellRing,
  'blinds': mdiBlinds,
  'boom-gate': mdiBoomGate,
  'border-top-variant': mdiBorderTopVariant,
  'briefcase-variant': mdiBriefcaseVariant,
  'cctv': mdiCctv,
  'ceiling-light': mdiCeilingLight,
  'cog': mdiCog,
  'cube-outline': mdiCubeOutline,
  'dolly': mdiDolly,
  'door': mdiDoor,
  'door-closed': mdiDoorClosed,
  'door-open': mdiDoorOpen,
  'door-sliding-lock': mdiDoorSlidingLock,
  'doorbell-video': mdiDoorbellVideo,
  'electric-switch': mdiElectricSwitch,
  'elevator': mdiElevator,
  'elevator-passenger': mdiElevatorPassenger,
  'engine': mdiEngine,
  'ev-station': mdiEvStation,
  'exit-run': mdiExitRun,
  'fan': mdiFan,
  'faucet': mdiFaucet,
  'fence': mdiFence,
  'fire': mdiFire,
  'fire-alert': mdiFireAlert,
  'fire-extinguisher': mdiFireExtinguisher,
  'fire-hydrant': mdiFireHydrant,
  'flash': mdiFlash,
  'floor-plan': mdiFloorPlan,
  'flower': mdiFlower,
  'format-paint': mdiFormatPaint,
  'garage': mdiGarage,
  'gauge': mdiGauge,
  'gesture-tap-button': mdiGestureTapButton,
  'grass': mdiGrass,
  'hanger': mdiHanger,
  'heat-pump': mdiHeatPump,
  'home': mdiHome,
  'home-floor-b': mdiHomeFloorB,
  'home-group': mdiHomeGroup,
  'home-modern': mdiHomeModern,
  'home-roof': mdiHomeRoof,
  'hvac': mdiHvac,
  'layers': mdiLayers,
  'layers-outline': mdiLayersOutline,
  'layers-triple': mdiLayersTriple,
  'lightbulb-group': mdiLightbulbGroup,
  'lightning-bolt': mdiLightningBolt,
  'lock': mdiLock,
  'lock-open-alert': mdiLockOpenAlert,
  'mailbox': mdiMailbox,
  'meter-electric': mdiMeterElectric,
  'meter-gas': mdiMeterGas,
  'monitor-dashboard': mdiMonitorDashboard,
  'nature': mdiNature,
  'office-building': mdiOfficeBuilding,
  'outdoor-lamp': mdiOutdoorLamp,
  'package-variant-closed': mdiPackageVariantClosed,
  'parking': mdiParking,
  'pine-tree': mdiPineTree,
  'pipe': mdiPipe,
  'pipe-valve': mdiPipeValve,
  'plus': mdiPlus,
  'power-plug': mdiPowerPlug,
  'power-socket-eu': mdiPowerSocketEu,
  'radiator': mdiRadiator,
  'road-variant': mdiRoadVariant,
  'rug': mdiRug,
  'server': mdiServer,
  'server-network': mdiServerNetwork,
  'shape-outline': mdiShapeOutline,
  'shield-half-full': mdiShieldHalfFull,
  'shower': mdiShower,
  'silverware-fork-knife': mdiSilverwareForkKnife,
  'slide': mdiSlide,
  'smoke': mdiSmoke,
  'smoke-detector': mdiSmokeDetector,
  'snowflake': mdiSnowflake,
  'sofa': mdiSofa,
  'solar-panel': mdiSolarPanel,
  'sprinkler-fire': mdiSprinklerFire,
  'sprout': mdiSprout,
  'stairs': mdiStairs,
  'star': mdiStar,
  'stop-circle': mdiStopCircle,
  'storage-tank': mdiStorageTank,
  'store': mdiStore,
  'stove': mdiStove,
  'tag': mdiTag,
  'texture-box': mdiTextureBox,
  'thermometer': mdiThermometer,
  'toilet': mdiToilet,
  'tree': mdiTree,
  'valve': mdiValve,
  'vector-line': mdiVectorLine,
  'vector-square': mdiVectorSquare,
  'walk': mdiWalk,
  'wall': mdiWall,
  'wallpaper': mdiWallpaper,
  'water': mdiWater,
  'water-boiler': mdiWaterBoiler,
  'water-check': mdiWaterCheck,
  'water-pump': mdiWaterPump,
  'water-thermometer': mdiWaterThermometer,
  'wheelchair-accessibility': mdiWheelchairAccessibility,
  'wifi': mdiWifi,
  'window-closed-variant': mdiWindowClosedVariant,
}

/** Every icon name the registry knows, sorted — what the picker lists. */
export const ASSET_TYPE_ICON_NAMES: string[] = Object.keys(ASSET_TYPE_ICONS)

/**
 * The `@mdi/js` path for a stored icon name, or `undefined` when the name is
 * absent, empty, or not one this build embeds. Callers fall back to their
 * family's default glyph rather than drawing nothing.
 */
export function iconPathFor(name: string | null | undefined): string | undefined {
  if (!name) return undefined
  return ASSET_TYPE_ICONS[name]
}
